import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const Personnel = ({ personnel, roles = [], onChange }) => {
	const { fullName, role } = personnel;

	const onFieldChange = (evt) => {
		const { name, value } = evt.target;
		if (onChange) {
			onChange(Object.assign(personnel, { [name]: value }));
		}
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={6}>
				<TextField
					id="fullName"
					name="fullName"
					label="Full Name"
					fullWidth
					value={fullName}
					onChange={onFieldChange}
					required
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<FormControl variant="outlined" fullWidth>
					<InputLabel htmlFor="role">Role</InputLabel>
					<Select
						id="role"
						name="role"
						label="Role"
						value={role}
						onChange={onFieldChange}
						required
					>
						<MenuItem value="" key="none">
							None
						</MenuItem>
						{roles.map((r) => (
							<MenuItem value={r.value} key={r.value}>
								{r.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};

export default Personnel;
